import { apiFetcher } from '~/apis/api-fetcher';

export const postCoupon = (couponId: number) => {
  return apiFetcher.post<{ data: boolean }>(`/api/coupon/v1/coupons/issues`, { couponId });
};
